import { applyRoleFromJwt, queryAuthStatus, sessionExpired } from "./authQueries.js";
import { queryMenu } from "./menuQueries.js";
import {
    getFetch,
    postFetch,
    putFetch,
    deleteFetch,
    createUrl,
    catchAPIResponse as httpCatchAPIResponse,
    catchAPIError,
} from "./http.js";

export { getFetch, postFetch, putFetch, deleteFetch, createUrl, catchAPIError };

export const executeFunctionsAfterPageLoad = (props) => {
    applyRoleFromJwt(props);
    queryAuthStatus(props);
};

export const executeFunctionsAfterConnectionEstablished = (props) => {
    const requiresLogin = props.auth.authStatus?.requiresLogin;
    const hasToken = Boolean(props.user.userJWT);
    if (!requiresLogin || hasToken) {
        queryMenu(props);
    }
};

export const successfulJwtValidation = (props, jwt) => {
    if (jwt) props.user.setUserJWT(jwt);
    props.user.setIsLoggedIn(true);
    props.server.setIsConnectionToServerEstablished(true);
};

export const catchAPIResponse = (props, response, options = {}) => {
    httpCatchAPIResponse(props, response, {
        ...options,
        onUnauthorized: options.checkExpired === false ? undefined : () => sessionExpired(props),
    });
};

export const standardGetQuery = (props, path, callback, options = {}) => {
    const { interval, condition } = options;

    const fetchData = () => {
        getFetch(path, props.user.userJWT, options)
            .then((response) => {
                if (response.ok) callback(response);
                else catchAPIResponse(props, response, options);
            })
            .catch((err) => catchAPIError(props, err, options));
    };

    fetchData();

    if (interval) {
        const loop = setInterval(() => {
            if (!condition || condition()) fetchData();
        }, interval * 1000);
        return () => clearInterval(loop);
    }
};

export const standardPostQuery = async (props, path, body, callback, options) => {
    await postFetch(path, body, props.user.userJWT)
        .then((response) => {
            if (response.ok) callback(response);
            else catchAPIResponse(props, response, options);
        })
        .catch((err) => catchAPIError(props, err, options));
};

export const standardPutQuery = async (props, path, body, callback) => {
    await putFetch(path, body, props.user.userJWT)
        .then((response) => {
            if (response.ok) callback(response);
            else catchAPIResponse(props, response);
        })
        .catch((err) => catchAPIError(props, err));
};
